import { render } from "./TenantSelector.vue?vue&type=template&id=048dad5c&scoped=true"
import script from "./TenantSelector.vue?vue&type=script&lang=js"
export * from "./TenantSelector.vue?vue&type=script&lang=js"

import "./TenantSelector.vue?vue&type=style&index=0&id=048dad5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048dad5c"]])

export default __exports__